var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoveToFolder = function SvgMoveToFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.001 12.265",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.589 12.265H1.412A1.43 1.43 0 0 1 0 10.839V1.427A1.43 1.43 0 0 1 1.412 0h5.234a.2.2 0 0 1 .15.07l1.3 1.539h6.493A1.43 1.43 0 0 1 16 3.036v7.8a1.43 1.43 0 0 1-1.411 1.429M5.303 6.444a.3.3 0 0 0-.3.3V7a.31.31 0 0 0 .3.315H9.06L7.868 8.502a.3.3 0 0 0-.089.215.3.3 0 0 0 .089.215l.184.184a.3.3 0 0 0 .216.089.3.3 0 0 0 .217-.09l2.02-2.02a.3.3 0 0 0 .089-.217.3.3 0 0 0-.089-.218l-2.02-2.02a.3.3 0 0 0-.217-.089.3.3 0 0 0-.216.089l-.184.184a.3.3 0 0 0-.089.216.3.3 0 0 0 .089.22l1.178 1.181Z",
    "data-name": "Differenzmenge 1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoveToFolder);
export default ForwardRef;